import Button from "@components/Button";
import CustomInput, {
  CustomSelectInput,
} from "@components/CustomInput/CustomInput";
import TableComponent from "@components/TableComponent/TableComponent";
import { Home } from "@mui/icons-material";
import styles from "./ManageDoctorPage.module.css";
import { useNavigate } from "react-router";
import useDoctor from "@hooks/useDoctor";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ManageDoctorPage = () => {
  const navigate = useNavigate();
  const { handleGetDoctor } = useDoctor();
  const { doctorData } = useSelector((state) => state.doctor);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [searchFilters, setSearchFilters] = useState({
    myReferenceNumber: "",
    firstName: "",
    contact: "",
    email: "",
    pincode: "",
    accountVerified: "",
    order: "",
  });
  const handleNavigateDoctorDetail = (email) => {
    navigate(`/doctor/${email}`);
  };

  function createData(refNo, firstName, contact, email, pincode, isVerified) {
    return {
      refNo,
      firstName,
      contact,
      email,
      pincode,
      isVerified: isVerified ? "Yes" : "No",
      view: (
        <Button
          text={"view"}
          onClick={() => handleNavigateDoctorDetail(email)}
        />
      ),
    };
  }

  const rows = doctorData?.data?.map((doctor) => {
    return createData(
      doctor.myReferenceNumber,
      doctor.local.firstName,
      doctor.local.contact,
      doctor.local.email,
      doctor.local.pincode,
      doctor.accountVerified.isVerified
    );
  });
  const columns = [
    { id: "refNo", label: "Reference No", minWidth: 170 },
    { id: "firstName", label: "First Name", minWidth: 100 },
    {
      id: "contact",
      label: "Contact",
      minWidth: 170,
      align: "left",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "email",
      label: "Email",
      minWidth: 170,
      align: "left",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "pincode",
      label: "Pincode",
      minWidth: 170,
      align: "left",
      format: (value) => value.toFixed(2),
    },
    {
      id: "isVerified",
      label: "isVerified",
      minWidth: 170,
      align: "left",
      format: (value) => value.toFixed(2),
    },
    {
      id: "view",
      label: "View",
      minWidth: 170,
      align: "left",
      format: (value) => value.toFixed(2),
    },
  ];

  const sortByOptions = [
    { option: "First Name", value: "local.firstName" },
    { option: "Email", value: "local.email" },
    { option: "Created At", value: "created_at" },
    { option: "Updated At", value: "updated_at" },
  ];
  const orderByOptions = [
    { option: "Ascending", value: 1 },
    { option: "Descending", value: -1 },
  ];

  const handleNavigateDashboard = () => {
    navigate("/");
  };

  const handleNavigatePatientPanel = () => {
    navigate("/managepatient");
  };

  const handleSearchInput = ({ target }) => {
    const { name, value } = target;
    setSearchFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const tableHeads = [
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="myReferenceNumber"
          value={searchFilters.myReferenceNumber}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="firstName"
          value={searchFilters.firstName}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="contact"
          value={searchFilters.contact}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="email"
          value={searchFilters.email}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomInput
          align={"left"}
          className={styles.Input}
          showSearchIcon
          name="pincode"
          value={searchFilters.pincode}
          onChange={handleSearchInput}
        />
      ),
    },
    {
      component: (
        <CustomSelectInput
          align="left"
          name="accountVerified"
          value={searchFilters.accountVerified}
          onChange={handleSearchInput}
          className={styles.VerifiedSelect}
          selectOptions={[
            { option: "Yes", value: true },
            { option: "No", value: false },
          ]}
        />
      ),
    },
  ];

  const searchFunction = () => {
    handleGetDoctor({ ...searchFilters, page: page + 1, limit: rowsPerPage });
  };

  useEffect(() => {
    handleGetDoctor({ ...searchFilters, page: page + 1, limit: rowsPerPage });
  }, [page, rowsPerPage, searchFilters?.order, searchFilters?.sortBy]);

  return (
    <div>
      <div className={styles.MenuWrapper}>
        <div className={styles.NavigationWrapper}>
          <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
          <div>
            <span
              className={styles.DashboardText}
              onClick={handleNavigateDashboard}
            >
              Dashboard
            </span>
            <span className={styles.RouteText}>/Doctor Panel</span>
          </div>
        </div>
        <div className={styles.ActionItemsWrapper}>
          <Button
            className={styles.BtnClass}
            text={"Manage Patient"}
            btnType={"secondary"}
            onClick={handleNavigatePatientPanel}
          />
          <CustomSelectInput
            className={styles.CustomSelect}
            selectOptions={sortByOptions}
            defaultOption={"Sort By"}
            value={searchFilters.sortBy}
            onChange={handleSearchInput}
            name={"sortBy"}
          />
          <CustomSelectInput
            selectOptions={orderByOptions}
            className={styles.CustomSelect}
            defaultOption={"Order By"}
            name={"order"}
            value={searchFilters.order}
            onChange={handleSearchInput}
          />
        </div>
      </div>
      <TableComponent
        tableHeads={tableHeads}
        columns={columns}
        rows={rows}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        page={page}
        setPage={setPage}
        totalRecords={doctorData?.total_record ?? 0}
        searchFunction={searchFunction}
      />
    </div>
  );
};
export default ManageDoctorPage;
